import { render, staticRenderFns } from "./ModalVoucher.vue?vue&type=template&id=35cab12d"
import script from "./ModalVoucher.vue?vue&type=script&lang=js"
export * from "./ModalVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports